module.exports = __webpack_public_path__ + "static/media/vacancy_item_1.3a6ea1c6.png";